import uploadErrorsTemplate from './upload-errors.html';

export default /* @ngInject */ $templateCache => {
	$templateCache.put('upload-errors.html', uploadErrorsTemplate);
};
